<template>
  <main>
    <Sidebar />
    <div
      :class="{ 'OrganizationsShow__page--expanded': expanded }"
      class="OrganizationsShow__page"
    >
      <router-view />
    </div>
  </main>
</template>

<script>
import './style.scss'
import { computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { onBeforeRouteUpdate } from 'vue-router'

import Sidebar from '@/components/Sidebar'

export default {
  name: 'OrganizationsShow',
  components: { Sidebar },
  setup() {
    const store = useStore()

    const expanded = computed(() => !store.state.sidebar.expanded)

    onMounted(() => {
      store.dispatch('fetchOrganization')
      store.dispatch('fetchOrganizationStatus')
    })

    onBeforeRouteUpdate((to, from, next) => {
      store.dispatch('fetchOrganizationStatus')
      next()
    })

    return {
      expanded,
    }
  },
}
</script>
